import { HttpParams } from "@angular/common/http";

export function toHttpParams(params):HttpParams{
    let queryParams = new HttpParams();
    for (const key in params) {
        queryParams = queryParams.set(key, params[key]);
    }
    return queryParams;
}